export default "__VITE_ASSET__B1gTe_cD__"